import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from './AdminAuthContainer';
import SettingsBody from './SettingsBody';
import SettingsHeader from './SettingsHeader';
import SettingsNav from './SettingsNav';
import Error403 from '../../pages/Error403';
import Loading from '../../pages/Loading';

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
`;

const Settings = () => {
    const { isAdmin, isSuperAdmin, isLoading } = useContainer(AdminAuthContainer);

    const showSettings = isAdmin || isSuperAdmin;

    if (isLoading) {
        return <Loading />;
    }

    if (!showSettings) {
        return <Error403 pt="32px" />;
    }

    return (
        <GridContainer>
            <SettingsHeader />

            <SettingsNav />
            <SettingsBody />
        </GridContainer>
    );
};

export default Settings;
